import VetCaseList from './VetCaseList';
import VetCaseShow from './VetCaseShow';

export default {
  list: VetCaseList,
  show: VetCaseShow,
};
